import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../services/operations/authAPI";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import "./loginn.css";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const { email, password } = formData;

  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    dispatch(login(email, password, navigate));
  };

  return (
    <div className="page-container" id="login">
      <div className="login-form">
        <h3 className="login-heading">Login</h3>
        <form className="form" onSubmit={handleOnSubmit}>
          <div className="flex-column">
            <label htmlFor="email">Email</label>
            <div className="inputForm">
              <input
                required
                type="text"
                name="email"
                value={email}
                onChange={handleOnChange}
                placeholder="Enter email address"
                className="input"
              />
            </div>
          </div>

          <div className="flex-column">
            <label htmlFor="password">Password</label>
            <div className="inputForm password-container">
              <input
                required
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={handleOnChange}
                placeholder="Enter password"
                className="input"
              />
              <span
                onClick={() => setShowPassword((prev) => !prev)}
                className="password-toggle-icon"
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>
          </div>

          <div className="flex-row">
            <div>
              
            </div>
            <Link to="/forgotPassword">
              <span className="span">Forgot password?</span>
            </Link>
          </div>

          <button type="submit" className="login-button">
            Log In
          </button>
        </form>

        <p className="p">Don't have an account?</p>
        <Link to="/signup">
          <button className="signup-button">Sign Up</button>
        </Link>

        {showPopup && (
          <div className="overlay">
            <div className="popup">
              <p>
                Your subscription has expired. Please contact your admin to renew.
              </p>
              <button onClick={() => setShowPopup(false)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
